import SideBarWithChildren from "../../../../shared/components/NavTab/SideBarWithChildren";
import Sidebar from "../../../../shared/components/Sidebar/Sidebar";
import React from "react";
import BusStationInfo from "../BusStationInfo/BusStationInfo";

const SlideMapMenu = () => {
    return (
        <SideBarWithChildren
            children={<BusStationInfo />}
        />
        // <Sidebar children={<></>} />
    )
}

export default SlideMapMenu; 